import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Services Component Header - title and subtitle
 */
export const animateServicesHeader = (ref, slides) => {
  if (ref.current && slides && slides.length > 0) {
    // Set initial state immediately to prevent flash
    const title = ref.current.querySelector('[class*="title"]');
    const subtitle = ref.current.querySelector('[class*="subtitle"]');
    
    if (title) {
      gsap.set(title, { opacity: 0, y: -30 });
    }
    if (subtitle) {
      gsap.set(subtitle, { opacity: 0, y: 20 });
    }
    
    const timer = setTimeout(() => {
      if (title) {
        gsap.to(title, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        });
      }
      
      if (subtitle) {
        gsap.to(subtitle, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        });
      }
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

